export const pushEvent = ( category, event, value ) => {
    console.warn('Analytics event:', category, event, value );
};
